<template>
  <DefaultContainer>
    <div slot="content" v-cloak>
      <v-row justify="center">
        <v-card color="#EEF7FE" class="mx-auto" width="800px" outlined>
          <v-list-item three-line>
            <img src="../../assets/logo.svg" height="80" width="200">
            <v-list-item-content class="mr-2">
              <v-list-item-title class="headline text-right mb-0 mt-7 mr-5">QuickLink</v-list-item-title>
              <v-list-item-subtitle class="text-right mb-7 mt-0 mr-5">powered by <a href="https://www.planetverify.com/" target="_blank">planetverify.com</a></v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-row>
      <v-row justify="center">
        <v-list-item three-line v-if="submitted">
          <v-list-item-content class="mr-2 text-center">
            <br/><br/><br/>
            <v-list-item-subtitle class="headline mb-1 mt-7 ml-5">Check your email or SMS</v-list-item-subtitle>
            <v-list-item-subtitle class="mb-7 mt-1 ml-5">(If you don't see the email check your spam/junk folder)</v-list-item-subtitle>
              <v-row justify="center">
                <v-icon color="blue" class="ml-7 my-7" size="100">far fa-envelope-open</v-icon>
              </v-row>
          </v-list-item-content>
        </v-list-item>
        <v-card v-if="!submitted" color="#EEF7FE" class="mx-auto" width="600px" outlined>
          <v-list-item three-line>
            <v-list-item-content class="mr-2 text-center">
              <v-form ref="quickLinkForm">
                <v-text-field v-if="email" v-model="emailValue" color="#55768f" placeholder="Email" :rules="validationRules(emailReq, true, false)"></v-text-field>
                <v-text-field v-if="mobile" v-mask="'+#############'" v-model="mobileValue" color="#55768f" placeholder="Mobile (include +country code e.g. +353871234567)" :rules="validationRules(mobileReq, false, true)"></v-text-field>
                <v-text-field v-if="firstName" v-model="firstNameValue" color="#55768f" placeholder="First Name" :rules="validationRules(firstNameReq, false, false)"></v-text-field>
                <v-text-field v-if="lastName" v-model="lastNameValue" color="#55768f" placeholder="Last Name" :rules="validationRules(lastNameReq, false, false)"></v-text-field>
                <template v-for="ref in noSetReferences">
                  <v-text-field v-model="ref.value" :key="ref.name" color="#55768f" :placeholder="ref.key" :rules="[validateRequiredRule]"></v-text-field>
                </template>
              </v-form>
            <v-btn color="blue" dark @click="createRequest">Start</v-btn>
            </v-list-item-content>
          </v-list-item>
        </v-card>
      </v-row>
    </div>
  </DefaultContainer>
</template>

<script>
import { mapState } from 'vuex';
import {
  CREATE_REQUEST
} from '@/store/actions.type';
import DefaultContainer from '@/containers/Default';
import { validateEmail, validatePhone } from '../../helpers/validation';
import uuidv4 from 'uuid/v4';

export default {
  name: 'request-details',
  components: {
    DefaultContainer
  },
  data() {
    return {
      references: [],
      noSetReferences: [],
      id: null,
      guestRequest: false,
      email: true,
      emailValue: '',
      emailReq: false,
      firstName: true,
      firstNameValue: '',
      firstNameReq: true,
      lastName: true,
      lastNameValue: '',
      lastNameReq: true,
      mobile: true,
      mobileValue: '',
      mobileReq: true,
      validateRequiredRule: v => !!v || 'This field is required',
      submitted: false,
      requesterId: null,
    };
  },
  methods: {
    validationRules(req, email, mobile){
      const rules = [];

      if(req){
        rules.push(this.validateRequiredRule);
      }

      if(email && this.emailValue != ''){
        rules.push(validateEmail);
      }

      if(mobile && this.mobileValue != ''){
        rules.push(validatePhone);
      }

      return rules;
    },
    async createRequest(){
      if(this.$refs.quickLinkForm.validate()){
        try {
          let refs = [];
          this.noSetReferences.forEach(el => {

            refs.push({ name : el.key, value : el.value, ordinal: el.ordinal})
          });
          this.references.forEach(el => {
            refs.push({ name : el.key, value : el.value, ordinal: el.ordinal})
          });
          await this.$store.dispatch(CREATE_REQUEST, {
            id: uuidv4(),
            isGuest: this.guestRequest,
            templateId: this.id,
            references: refs,
            email: this.emailValue,
            mobile: this.mobileValue,
            firstName: this.firstNameValue,
            lastName: this.lastNameValue,
            requesterId: this.requesterId
          });
        } catch (err) {
          this.showError();
        }
        this.submitted = true
      }
    },
    showError(title, message) {
      this.errorTitle = title || 'Failed';
      this.errorMessage = message || 'Please try again. If the problem persists you can contact us for assistance.';
      this.errorDialog = true;
      this.loading = false;
    }
  },
  async mounted() {
      var i = 0;
      Object.keys(this.$route.query).forEach(key => {
        if(!['e', 'em', 'f', 'fm', 'g', 'id', 'l', 'lm','m','mm', 'r'].includes(key)){
          if(this.$route.query[key] === 'noset'){
            this.noSetReferences.push({ key : key, value : '', ordinal: i});
          }
          else{
            this.references.push({ key : key, value : this.$route.query[key], ordinal: i});
          }
          i = i+1;
        }
      });

      this.id = this.$route.query.id
      this.requesterId = this.$route.query.r
      this.guestRequest = this.$route.query.g.toLowerCase() == "true"
      this.email = this.$route.query.e.toLowerCase() == "true"
      this.emailReq = this.$route.query.em.toLowerCase() == "true"
      this.firstName = this.$route.query.f.toLowerCase() == "true"
      this.firstNameReq = this.$route.query.fm.toLowerCase() == "true"
      this.lastName = this.$route.query.l.toLowerCase() == "true"
      this.lastNameReq = this.$route.query.lm.toLowerCase() == "true"
      this.mobile = this.$route.query.m.toLowerCase() == "true"
      this.mobileReq = this.$route.query.mm.toLowerCase() == "true"
},
}
</script>

<style>
.theme--dark.v-toolbar {
  background-color: #2596ee;
}
.request-terms {
  width: 100%;
  height: calc(100vh - 56px);
}
.request-details-page {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
}
.request-details-page .container {
  padding: 0;
}
.request-details-page .v-toolbar {
  flex-grow: 0;
}
.request-details-steps {
  flex-grow: 1;
  box-shadow: none;
}
.request-details-steps .v-stepper__content:not(.step-completed) .v-stepper__wrapper {
  box-shadow: 0;
}
.v-stepper__content {
    padding: 0 !important;
}
.v-stepper {
    max-width: 800px !important;
}
.theme--light.v-stepper {
  background: none;
}
.theme--light.v-stepper .v-stepper__step--editable:hover {
  background: none;
}
.theme--light.v-stepper--non-linear .v-stepper__step:not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__label,
.theme--light.v-stepper .v-stepper__label small {
  color: #144062;
}
.v-btn {
  min-width: 0;
}
.v-overlay--active::before {
  background-color: rgb(20, 64, 98);
  opacity: 0.85;
}
.btn-accept-terms {
  position: absolute;
  bottom: 22px;
  left: 50%;
  transform: translateX(-50%);
}
.btn-accept-terms:hover,
.btn-accept-terms:focus {
  position: absolute;
}
.terms-content {
  padding-bottom: 80px;
}
.v-stepper__label {
  color: #144062;
  font-size: 16px;
  font-weight: 700;
}
.v-card__actions {
  justify-content: center;;
}
.submit-btn {
  min-width: 165px;
}
.card-completed {
  background: none !important;
}
.label-completed {
  font-size: 12px;
  color: #55768f;
  margin-bottom: 4px;
}
.value-completed {
  color: #144062;
  margin-bottom: 18px;
}
.section-title {
  margin-bottom: 10px;
}
.section-title:not(:first-child) {
  margin-top: 25px;
}
.v-stepper__step:hover .v-stepper__label {
  text-decoration: underline;
}
.request-details-page .v-stepper__step:hover .v-stepper__label {
  text-decoration: none;
}
</style>
